import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'about-menu',
  standalone: true,
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './about-menu.component.html',
  styleUrls: ['./about-menu.component.css'],
})
export class AboutMenuComponent {

}
